/* src/app/shared/library-button/library-button.component.scss */
.copy-link {
  border: 1px solid white;
  text-transform: uppercase;
  display: flex;
  padding: 15px 30px 10px 20px;
  border-radius: 30px;
  position: absolute;
  right: 85px;
  top: 55px;
  font-family: "Campton-Bold";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1px;
}
.copy-link.white-background {
  border: 1px solid #6DCC09;
  color: #6DCC09;
}
.copy-link.white-background svg {
  fill: #6DCC09;
}
.copy-link:hover {
  cursor: pointer;
}
.copy-link:hover {
  color: #6DCC09;
  border: 1px solid #6DCC09;
}
.copy-link:hover svg {
  fill: #6DCC09;
}
.library-button {
  border: 1px solid white;
  text-transform: uppercase;
  display: flex;
  padding: 15px 30px 10px 20px;
  border-radius: 30px;
  position: absolute;
  left: 100px;
  top: 55px;
  font-family: "Campton-Bold";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1px;
}
.library-button:hover {
  cursor: pointer;
}
.library-button svg {
  fill: white;
}
.library-button.white-background {
  border: 1px solid #6DCC09;
  color: #6DCC09;
}
.library-button.white-background svg {
  fill: #6DCC09;
}
.library-button:hover {
  color: #6DCC09;
  border: 1px solid #6DCC09;
}
.library-button:hover svg {
  fill: #6DCC09;
}
/*# sourceMappingURL=library-button.component.css.map */
